import React from 'react';
import { cn } from '../../lib/utils';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'danger' | 'warning' | 'info' | 'destructive' | 'secondary' | 'outline';
  className?: string;
  style?: React.CSSProperties;
}

export const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  className = '',
  style
}) => {
  const baseClasses = 'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium transition-colors';
  
  const variantClasses = {
    default: 'bg-slate-700 text-slate-300',
    secondary: 'bg-slate-600 text-slate-200',
    success: 'bg-green-900/30 text-green-400 border border-green-700/50',
    danger: 'bg-red-900/30 text-red-400 border border-red-700/50',
    destructive: 'bg-red-900/30 text-red-400 border border-red-700/50',
    warning: 'bg-yellow-900/30 text-yellow-400 border border-yellow-700/50',
    info: 'bg-blue-900/30 text-blue-400 border border-blue-700/50',
    outline: 'border border-gray-500 text-gray-300 bg-transparent'
  };

  return (
    <span className={cn(baseClasses, variantClasses[variant], className)} style={style}>
      {children}
    </span>
  );
};

export default Badge;
